import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_EN.json';
import guides from './MEDITATION_GUIDES_EN.json';

export const MEDITATION_DATA_EN: ServiceData = {
  audios,
  guides,
};
